export default "__VITE_ASSET__CYKzczm7__"